import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mrn-approval-form',
  templateUrl: './mrn-approval-form.component.html',
  styleUrls: ['./mrn-approval-form.component.css']
})
export class MrnApprovalFormComponent implements OnInit {
  title="MRN Approval";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/mrn-approval/mrn-approval-form/mrn-approval-form.component.ts